// @Interfaces and Types
export type ErrorType = {
  status: string | number;
  kind: string;
  title: string;
  des: string;
};

export const initialIsError: ErrorType | null = null;
